import "./QueryHeroSection.scss";
import BACKGROUND_IMAGE from "../../../assets/images/denim/Denim_Hero.webp";

const QueryHeroSection = ({text = '', subText = '', backgroundImage = BACKGROUND_IMAGE,}) => {
  return (
    <section className="query_hero"  style={{
        backgroundImage: `url(${backgroundImage})`,
      }}>
      <div className="query_hero__overlay">
        <div className="query_hero__content">
          <h1 className="query_hero__title">
            {text}
          </h1>
          <p className="query_hero__subtitle">
            {subText}
          </p>
        </div>
      </div>
    </section>
  );
};

export default QueryHeroSection;
